// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"238":"0f2aa041","755":"6396aab9"}[chunkId] + ".css";
};